import React from 'react';
import { NavLink, Link, Outlet, useNavigate } from 'react-router-dom';
import { getSession, clearSession } from './auth';
import './styles/admin-shared.css';

const NAV_GROUPS = [
  {
    title: 'Pilotage',
    items: [
      { to: '/admin/dashboard',    label: "Vue d'ensemble", ico: '◔' },
      { to: '/admin/moderation',   label: 'Modération',     ico: '◑', badge: '12' },
      { to: '/admin/statistiques', label: 'Statistiques',   ico: '◢' },
    ],
  },
  {
    title: 'Contenus',
    items: [
      { to: '/admin/actualites', label: 'Actualités',         ico: '▤', badge: '38', mutedBadge: true },
      { to: '/admin/archives',   label: 'Histoire & archives', ico: '▥' },
      { to: '/admin/galerie',    label: 'Galerie',             ico: '▩', badge: '480+', mutedBadge: true },
      { to: '/admin/tourisme',   label: 'Tourisme',            ico: '⌖' },
    ],
  },
  {
    title: 'Communauté',
    items: [
      { to: '/admin/membres',  label: 'Membres',  ico: '◌', badge: '3 200', mutedBadge: true },
      { to: '/admin/talents',  label: 'Talents',  ico: '★' },
      { to: '/admin/annuaire', label: 'Annuaire', ico: '◧' },
    ],
  },
  {
    title: 'Mairie',
    items: [
      { to: '/admin/chantiers',    label: 'Chantiers',          ico: '◰' },
      { to: '/admin/conseil',      label: 'Conseil municipal',  ico: '◫' },
      { to: '/admin/seances',      label: 'Séances & PV',       ico: '⌥' },
      { to: '/admin/caisse',       label: 'Caisse du village',  ico: '◈' },
      { to: '/admin/agenda',       label: 'Agenda événements',  ico: '☷' },
      { to: '/admin/signalements', label: 'Signalements',       ico: '⚑', badge: '7' },
    ],
  },
  {
    title: 'Système',
    items: [
      { to: '/admin/newsletter', label: 'Newsletter', ico: '✉' },
    ],
  },
];

const AdminLayout = () => {
  const navigate = useNavigate();
  const session = getSession() || {};
  const onLogout = () => {
    clearSession();
    navigate('/connexion');
  };

  return (
    <div className="app">
      <aside className="sidebar">
        <Link className="brand" to="/">
          <span className="brand-mark"></span>
          <span>Cambérène<small>Admin · 221</small></span>
        </Link>

        <div className="workspace">
          <span className="av">CM</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <b>Mairie de Cambérène</b>
            <small>Workspace · Prod</small>
          </div>
          <span className="chev">▾</span>
        </div>

        <div className="nav-group">
          {NAV_GROUPS.map((group) => (
            <React.Fragment key={group.title}>
              <h6>{group.title}</h6>
              {group.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) => `nav-item${isActive ? ' on' : ''}`}
                >
                  <span className="ico">{item.ico}</span>
                  {item.label}
                  {item.badge && (
                    <span className={`badge${item.mutedBadge ? ' muted' : ''}`}>{item.badge}</span>
                  )}
                </NavLink>
              ))}
            </React.Fragment>
          ))}
        </div>

        <div className="sidebar-foot">
          <span className="pf"></span>
          <div style={{ minWidth: 0 }}>
            <b>{session.name || 'Admin'}</b>
            <small>{session.title || 'Admin'}</small>
          </div>
          <button className="out" onClick={onLogout} title="Déconnexion" aria-label="Déconnexion">⤴</button>
        </div>
      </aside>

      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
